import React, { useContext } from 'react';
import Immutable from 'immutable';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Dropdown, DropdownMenuItem } from '@bibliocommons/base-dropdown';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { metadataIdFixer } from '@bibliocommons/utils-link';
import Context from '@bibliocommons/context';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import RedirectActions from 'app/actions/RedirectActions';
import FullScreenOverlayActions from 'app/actions/FullScreenOverlayActions';
import { FullScreenOverlayContainer } from 'app/components/shared/FullScreenOverlay';
import AddToListOverlay from './AddToListOverlay';

export default function AddToListDropdown({ catalogBib, block, overlayKey }) {
  const dispatch = useDispatch();
  const { mobileApp } = useContext(Context);
  const bibId = metadataIdFixer(catalogBib.get('metadataId'));

  function handleAddToNewList() {
    dispatch(RedirectActions.redirect(`/user_lists/new?bib=${bibId}`, { authRequired: true }));
  }

  function openOverlay() {
    dispatch(FullScreenOverlayActions.openOverlay(overlayKey, { authRequired: true }));
  }

  function closeOverlay() {
    dispatch(FullScreenOverlayActions.closeOverlay(overlayKey));
  }

  function renderNewListMenuItem() {
    return (
      <DropdownMenuItem
        handleClick={handleAddToNewList}
        item={Immutable.Map({
          label: <FormattedMessage id="add_to_list_new" />,
          value: 'add-to-new-list'
        })}
      />
    );
  }

  function renderExistingListMenuItem() {
    const label = (
      <>
        <span aria-hidden>
          <FormattedMessage id="add_to_list_existing" />
        </span>
        <ScreenReaderMessage>
          <FormattedMessage id="sr_add_to_list_existing" />
        </ScreenReaderMessage>
      </>
    );
    return (
      <DropdownMenuItem
        handleClick={openOverlay}
        item={Immutable.Map({
          label,
          value: 'add-to-existing-list'
        })}
      />
    );
  }

  return mobileApp ? null : (
    <div className="cp-add-to-list-dropdown">
      <Dropdown block={block} dataKey="add-to-list-dropdown" renderLabel={() => <FormattedMessage id="add_to_list" />}>
        {renderNewListMenuItem()}
        {renderExistingListMenuItem()}
      </Dropdown>
      <FullScreenOverlayContainer dataKey="add-to-list-overlay" overlayKey={overlayKey} handleClose={closeOverlay}>
        <AddToListOverlay catalogBib={catalogBib} />
      </FullScreenOverlayContainer>
    </div>
  );
}

AddToListDropdown.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  block: PropTypes.bool,
  overlayKey: PropTypes.string.isRequired
};
